import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {IntegrationDetails} from './integrationDetails.js';
import {IntegrationLocks} from './integrationLocks.js';
import {IntegrationProperties} from './integrationProperties.js';
import {IntegrationRuns} from './integrationRuns.js';
import {IntegrationAddEdit} from './integrationAddEdit.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {SessionStorageUtil} from '../../utils/browserStorageSanitizer.js';


/* global customElements */
class IntegrationGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean},
			widgetmode: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		this.admin = false;
		this.widgetmode = false;
		
		var integrationGrid = this;
		setTimeout(function(){
			integrationGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var integrationGrid = this;
		
		// Filtered list for create/filter UI; full list for edit lookup (FTP/SFTP etc. are admin-create-only).
		var transmissionTypes = [];
		var allTransmissionTypes = [];

		var applyTransmissionDefinitions = function(data) {
			allTransmissionTypes = (data || []).slice(0);
			if (!integrationGrid.admin) {
				var filtered = [];
				allTransmissionTypes.forEach(function(item){
					if (item.userAvailable) {
						filtered.push(item);
					}
				});
				transmissionTypes = filtered;
			} else {
				transmissionTypes = allTransmissionTypes.slice(0);
			}
			var filterCombo = ElementUtil.query(toolbarFilter, 'filterTransmissionType');
			if (filterCombo) {
				filterCombo.items = transmissionTypes.slice(0);
			}
		};

		var findTransmissionDefinition = function(type) {
			var definition;
			allTransmissionTypes.forEach(function(item){
				if (item.transmissionType === type) {
					definition = item;
				}
			});
			return definition;
		};
	
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [	
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterModule',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Module',
					'item-value-path': 'code',
					'item-label-path': 'description',				
					postinit: function(combo) {
						
						DataManagementService.getIntegrationService().getAvailableModules().then(function(data) {
							combo.items = data;
						});
//						
//						Service.getLookupService().getLookupValues('ApplicationModule').then(function(data){
//							var filtered = [];
//							data.forEach(function(item){
//								if (item.dataFeed) {
//									if (item.restricted) {
//										if (integrationGrid.admin) {
//											filtered.push(item);
//										}
//									} else {
//										filtered.push(item);
//									}
//								}
//							});
//							combo.items = filtered;
//							if (filtered.length > 0) {
//								combo.value = filtered[0].code;
//							}
//						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}					
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterStatus',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Status',
					'item-value-path': 'code',
					'item-label-path': 'description',
					value: 'A',
					postinit: function(combo) {
						DataManagementService.getIntegrationService().getAvailableStatus().then(function(data){
							combo.items = data;
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {						
							actionRefresh();
						}
					}					
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterTransmissionType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Transmission Type',
					'item-value-path': 'transmissionType',
					'item-label-path': 'transmissionDescription',
					postinit: function(combo) {
						DataManagementService.getIntegrationService().getDefinitions().then(function(data){
							applyTransmissionDefinitions(data);
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {						
							actionRefresh();
						}
					}					
				},
				{
					tag: 'vaadin-combo-box',
					itemid: 'filterField',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					style: 'width: 10em;',
					value: 'name',
					postinit: function(combo) {
						combo.items = [
							{ code: 'name', description: 'Name' },
							{ code: 'configId', description: 'Config Id' }
						];
					},
					listeners: {
						change: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					style: 'width: 250px;',
					label: 'Filter Value',
					clearButtonVisible: true,
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
						},
						change: function() {
							actionRefresh();
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (integrationGrid.admin ? '' : 'display: none;'),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',				
					postinit: function(combo) {
						if (integrationGrid.admin) {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							if (integrationGrid.admin) {								
								var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;							
							}
							actionRefresh();
						}
					}					
				}
			]
		});
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					itemId: 'mainToolSeparator-refresh',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_INTEGRATIONS:WRITE', 'INTEGRATIONS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',					
					'class': 'spacer-toolbar-item',					
					disabled: true,
					permissions: ['ADMIN_INTEGRATIONS:WRITE', 'INTEGRATIONS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					itemId: 'mainToolSeparator',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'details',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_INTEGRATIONS:READ', 'INTEGRATIONS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:tasks', ' Details')						
					],
					listeners: {
						click: function() {
							actionShowDetails(grid.selectedItems[0]);
						}
					}					
				},				
				{
					tag: 'dl-action-button',
					itemid: 'runs',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_INTEGRATIONS:READ', 'INTEGRATIONS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:play', ' Runs')						
					],
					listeners: {
						click: function() {
							actionRuns(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'manage-config-tools',
					'class': 'spacer-toolbar-item',										
					children:[
						ElementUtil.makeIcon('vaadin:wrench', ' Tools')						
					],
					properties: {
						menu: [		
							{
								tag: 'dl-action-menu-item',
								itemId: 'checkConnectivity',
								disabled: true,
								permissions: ['ADMIN_INTEGRATIONS:READ', 'INTEGRATIONS:READ'],
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:check-circle"></vaadin-icon> Check Connectivity',
								listeners: {
									click: function() {
										actionCheckConnectivity(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'feedback',	
								disabled: true,	
								ppermissions: ['ADMIN_INTEGRATIONS:WRITE', 'INTEGRATIONS:WRITE'],
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:envelope-open-o"></vaadin-icon> Request Support',
								listeners: {
									click: function(event) {
										actionRequestTrouble(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'updateStatus',	
								disabled: true,	
								ppermissions: ['ADMIN_INTEGRATIONS:UPDATE_STATUS', 'INTEGRATIONS:UPDATE_STATUS'],
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:arrow-circle-up"></vaadin-icon> Update Status',
								listeners: {
									click: function(event) {
										actionUpdateStatus(grid.selectedItems);
									}
								}
							},									
							{
								tag: 'dl-action-menu-item',
								itemId: 'resetRun',
								disabled: true,
								permissions: ['ADMIN_INTEGRATIONS:UPDATE_STATUS'],									
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:arrow-backward"></vaadin-icon> Reset Run Status',
								listeners: {
									click: function(event) {
										actionResetRunStatus(grid.selectedItems);	
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'backPull',
								disabled: true,
								permissions: ['ADMIN_INTEGRATIONS:WRITE', 'INTEGRATIONS:WRITE'],									
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:arrow-circle-left"></vaadin-icon> Back Pull Data',
								listeners: {
									click: function(event) {
										actionBackPull(grid.selectedItems[0]);	
									}
								}
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'updatePullDates',
								disabled: true,
								permissions: ['ADMIN_INTEGRATIONS:WRITE', 'INTEGRATIONS:WRITE'],
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:calendar"></vaadin-icon> Update Pull Dates',
								listeners: {
									click: function(event) {
										actionUpdatePullDates(grid.selectedItems[0]);
									}
								}
							}
						]
					}
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
					{
							tag: 'dl-action-button',
							itemid: 'manage-tools',
							'class': 'spacer-toolbar-item',
							style: '' + (integrationGrid.admin ? '' : 'display: none;'),
							permissions: ['ADMIN_TRANSMISSION_PROPERTIES:READ,ADMIN_INTEGRATION_LOCKS:WRITE,ADMIN_INTEGRATIONS:WRITE'],
							children:[
								ElementUtil.makeIcon('vaadin:cogs', ' Manage')						
							],
							properties: {
								menu: [																
									{
										tag: 'dl-action-menu-item',
										itemId: 'transmissionProperties',										
										permissions: ['ADMIN_TRANSMISSION_PROPERTIES:READ'],
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:modal-list"></vaadin-icon> Transmission Properties',
										listeners: {
											click: function(event) {
												actionTransmissionProperties();
											}
										}
									},									
									{
										tag: 'dl-action-menu-item',
										itemId: 'templates',
										permissions: ['ADMIN_INTEGRATIONS:WRITE'],									
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:copy"></vaadin-icon> Templates',
										listeners: {
											click: function(event) {
												actionTemplates();	
											}
										}
									},									
									{
										tag: 'dl-action-menu-item',
										itemId: 'locks',
										permissions: ['ADMIN_INTEGRATION_LOCKS:WRITE'],									
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:lock"></vaadin-icon> Locks',
										listeners: {
											click: function(event) {
												actionLocks();
											}
										}
									}
								]
							}
						},
						{
							tag: 'span',
							itemId: 'mainToolSeparator-delete',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							theme: 'error primary',					
							permissions: ['ADMIN_INTEGRATIONS:DELETE', 'INTEGRATIONS:DELETE'],
							'class': 'spacer-toolbar-item',
							disabled: true,
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}		
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});		
			
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [	
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-width': true,
					'auto-select': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},				
				{					
					path: 'applicationModuleDescription',
					header: 'Module',
					resizable: true,
					width: '6em'
				},
				{
					tag: 'vaadin-grid-column',
					path: 'failsRunsSinceLastSuccess',
					header: 'Status',					
					width: '50px',
					resizable: true,
					'text-align': 'center',
					renderer: function(root, column, rowData) {	
						var output = '';						
						if (rowData.item.failsRunsSinceLastSuccess === 0) {
							output = '<span class="data-feed-status-healthy" title="Healthy"></span>';
						} else if (rowData.item.failsRunsSinceLastSuccess > 0 && rowData.item.failsRunsSinceLastSuccess < 5) {
							output = '<span class="data-feed-status-unhealthy" title="Unhealthy"></span>';
						} else {
							output = '<span class="data-feed-status-failure" title="Failure"></span>';
						}
						
						if (rowData.item.warningState) {
							output += '<br><b>' + rowData.item.warningState + '</b>';
						}						
						root.innerHTML = output;
					}
				},
				{					
					path: 'name',
					header: 'Name',
					resizable: true,
					width: '8em'
				},
				{						
					path: 'configId',
					header: 'Config Id',
					resizable: true,				
					width: '7em'
				},
				{						
					path: 'companyName',
					header: 'Company Name',
					resizable: true,
					'text-align': 'center',
					width: '7em'
				},	
				{						
					path: 'runStatusDescription',
					header: 'Run Status',
					resizable: true,
					width: '7em'
				},
				{										
					path: 'lastRunDate',
					header: 'Last Run Date',
					resizable: true,
					width: '7em',					
					renderer: function(root, column, rowData) {						
						root.innerHTML = TimeUtil.formatDateStandard(rowData.item.lastRunDate);						
					}
				},
				{						
					path: 'transmissionDescription',
					header: 'Transmission Type',
					resizable: true,
					width: '7em'
				},
				{						
					path: 'applicationModule',
					header: 'Module Code',
					resizable: true,
					hidden: true,
					width: '7em'
				},
				{						
					path: 'transmissionType',
					header: 'Transmission Type Code',
					resizable: true,
					hidden: true,
					width: '7em'
				},
				{						
					path: 'timingDescription',
					header: 'Timing',
					resizable: true,
					hidden: true,
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
		
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {	

					ElementUtil.query(toolbar, 'updateStatus ').disabled = false; 

					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'delete').disabled = false; 			
						if (grid.selectedItems[0].runStatus !== 'WORKING' && grid.selectedItems[0].runStatus !== 'QUEUED') {
							ElementUtil.query(toolbar, 'edit').disabled = false;
						} else {
							ElementUtil.query(toolbar, 'edit').disabled = true;
						}
						ElementUtil.query(toolbar, 'details').disabled = false;
						ElementUtil.query(toolbar, 'updateStatus').disabled = false;
						
						if (integrationGrid.admin) {
							ElementUtil.query(toolbar, 'resetRun').disabled = false;
						}
						ElementUtil.query(toolbar, 'feedback').disabled = false;
						ElementUtil.query(toolbar, 'runs').disabled = false;
						ElementUtil.query(toolbar, 'checkConnectivity').disabled = false;
						
						if (grid.selectedItems[0].backPullAvailable) {
							ElementUtil.query(toolbar, 'backPull').disabled = false;
						} else {
							ElementUtil.query(toolbar, 'backPull').disabled = true;
						}
						ElementUtil.query(toolbar, 'updatePullDates').disabled = false;
						
					} else {
						ElementUtil.query(toolbar, 'updateStatus').disabled = false;
						if (integrationGrid.admin) {
							ElementUtil.query(toolbar, 'resetRun').disabled = false;
						}
						ElementUtil.query(toolbar, 'feedback').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = true; 			
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'details').disabled = true;
						ElementUtil.query(toolbar, 'runs').disabled = true;
						ElementUtil.query(toolbar, 'checkConnectivity').disabled = true;
						ElementUtil.query(toolbar, 'backPull').disabled = true;
						ElementUtil.query(toolbar, 'updatePullDates').disabled = true;
					}						
				} else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;
					ElementUtil.query(toolbar, 'details').disabled = true;
					ElementUtil.query(toolbar, 'runs').disabled = true;
					ElementUtil.query(toolbar, 'updateStatus').disabled = true;
					ElementUtil.query(toolbar, 'backPull').disabled = true;
					ElementUtil.query(toolbar, 'updatePullDates').disabled = true;					
					if (integrationGrid.admin) {
						ElementUtil.query(toolbar, 'resetRun').disabled = true;
					}					
					ElementUtil.query(toolbar, 'feedback').disabled = true;
					ElementUtil.query(toolbar, 'checkConnectivity').disabled = true;
					ElementUtil.query(toolbar, 'delete').disabled = true; 
				}
			});
		};
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function(companyId) {
						integrationGrid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'companyName',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',
							companyId: companyId,
							status: ElementUtil.query(toolbarFilter, 'filterStatus').value, 
							module: ElementUtil.query(toolbarFilter, 'filterModule').value,
							transmissionType: ElementUtil.query(toolbarFilter, 'filterTransmissionType').value
						};

						var filterField = ElementUtil.query(toolbarFilter, 'filterField').value;
						var filterValue = ElementUtil.query(toolbarFilter, 'filterValue').value;
						if (filterField && filterValue) {
							integrationGrid.currentFilter.filterField = filterField;
							integrationGrid.currentFilter.filterValue = filterValue;
						}

						var successHandler = function(records) {
							loadMask.remove();
							
							//clear selection; setting the active item to null (re-add in item in multi-select)																			
							grid.items = records.data;
							grid.selectedItems = [];										
							gridSelectionChange();
						

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};

						DataManagementService.getIntegrationService().getIntegrations(integrationGrid.currentFilter)
								.then(function(records){							
							successHandler(records);
						});	
					};					
					
					if (!integrationGrid.admin) {
						Service.getCompanyService().getCurrentCompany().then(function(companyFull){
							loadData(companyFull.company.companyId);
						});
					} else {
						loadData(ElementUtil.query(toolbarFilter, 'filterCompany').value);
					}					
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});				
			
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, integrationGrid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				DataManagementService.getIntegrationService().exportIntegrations(exportFilter);
			}
		});
		var exportToolbar = footer.exportToolbar;
			
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		integrationGrid.append(flexLayout);		
				
		if (integrationGrid.widgetmode) {
			setTimeout(function(){
				ElementUtil.query(toolbar, 'add').classList.add('hide');
				ElementUtil.query(toolbar, 'edit').classList.add('hide');
				ElementUtil.query(toolbar, 'details').classList.add('hide');
				ElementUtil.query(toolbar, 'runs').classList.add('hide');
				ElementUtil.query(toolbar, 'manage-config-tools').classList.add('hide');
				ElementUtil.query(toolbar, 'manage-tools').classList.add('hide');
				ElementUtil.query(toolbar, 'delete').classList.add('hide');
				ElementUtil.query(toolbar, 'mainToolSeparator').classList.add('hide');
				ElementUtil.query(toolbar, 'mainToolSeparator-refresh').classList.add('hide');
				ElementUtil.query(toolbar, 'mainToolSeparator-delete').classList.add('hide');
				toolbarFilter.classList.add('hide');
				exportToolbar.classList.add('hide');
			});
		}		
				
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		attachWorkspaceFilterState(integrationGrid, toolbarFilter, ['filterCompany','filterModule','filterStatus','filterTransmissionType','filterField','filterValue'], actionRefresh);
	
		var openAddEdit = function(record) {
			IntegrationAddEdit.addEditIntegration(record, {
				admin: integrationGrid.admin,
				transmissionTypes: transmissionTypes,
				companyId: ElementUtil.query(toolbarFilter, 'filterCompany').value,
				findTransmission: findTransmissionDefinition,
				successCallback: function() {
					if (!record) {
						ElementUtil.query(toolbarFilter, 'filterStatus').value = 'P';						
					}
					actionRefresh();
				}
			});
		};

		var actionAddEdit = function(record) {
			// Full definition list is required for edit (types like FTP/SFTP are not userAvailable).
			if (allTransmissionTypes && allTransmissionTypes.length > 0) {
				openAddEdit(record);
				return;
			}
			var loadMask = grid.showLoading('Loading transmission types...');
			DataManagementService.getIntegrationService().getDefinitions().then(function(data) {
				applyTransmissionDefinitions(data);
				loadMask.remove();
				openAddEdit(record);
			}).catch(function() {
				loadMask.remove();
				window.DL.MessageUtil.showOkMessage('Unable to load transmission types.');
			});
		};
		
		var actionRuns = function(record) {
			IntegrationRuns.manageRuns(record);
		};		
		
		var actionBackPull = function(record) {
			IntegrationRuns.backPull(record);
		};

		var actionUpdatePullDates = function(record) {
			var updateWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Update Pull Dates',
				icon: 'vaadin:calendar',
				width: 520,
				height: 420,
				listeners: {
					ready: function() {
						updateWin.show();

						var configFiles = [];
						var pullHint = record.pullUsesDataReceivedDate
							? 'This feed windows the next pull using Last Data Received Date.'
							: 'This feed windows the next pull using Run Date.';

						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'div',
											colspan: 2,
											style: 'padding: 8px 0; color: var(--lumo-secondary-text-color);',
											innerHTML: pullHint
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Config File',
											name: 'configFileId',
											'item-value-path': 'configFileId',
											'item-label-path': 'label',
											required: true,
											colspan: 2,
											postinit: function(combo) {
												DataManagementService.getIntegrationService().getIntegrationDetail(record.configId).then(function(detail) {
													configFiles = (detail.files || []).map(function(file) {
														var labelParts = [];
														if (file.dataType) {
															labelParts.push(file.dataType);
														}
														if (file.fileName) {
															labelParts.push(file.fileName);
														}
														labelParts.push(file.configFileId);
														return {
															configFileId: file.configFileId,
															label: labelParts.join(' / '),
															runDate: file.runDate,
															lastDataReceivedDate: file.lastDataReceivedDate
														};
													});
													combo.items = configFiles;
													if (configFiles.length === 1) {
														combo.value = configFiles[0].configFileId;
														combo.dispatchEvent(new Event('change'));
													}
												});
											},
											listeners: {
												change: function(event) {
													var selectedId = event.target.value;
													var selectedFile = configFiles.find(function(file) {
														return file.configFileId === selectedId;
													});
													var runDateField = ElementUtil.query(formPanel, 'runDate');
													var lastDataField = ElementUtil.query(formPanel, 'lastDataReceivedDate');
													if (selectedFile) {
														runDateField.value = selectedFile.runDate
															? TimeUtil.formatDateForDateTimeLoad(selectedFile.runDate)
															: '';
														lastDataField.value = selectedFile.lastDataReceivedDate
															? TimeUtil.formatDateForDateTimeLoad(selectedFile.lastDataReceivedDate)
															: '';
													} else {
														runDateField.value = '';
														lastDataField.value = '';
													}
												}
											}
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Run Date (mm/dd/yyyy hh:mm:ss)',
											name: 'runDate',
											itemid: 'runDate',
											step: 1,
											colspan: 2
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Last Data Received Date (mm/dd/yyyy hh:mm:ss)',
											name: 'lastDataReceivedDate',
											itemid: 'lastDataReceivedDate',
											step: 1,
											colspan: 2
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {
															formPanel.submitForm({
																preSubmit: function(data) {
																	return data;
																},
																actualCall: function(data) {
																	if (!data.runDate && !data.lastDataReceivedDate) {
																		window.DL.MessageUtil.showToastError(
																			'Enter at least one of Run Date or Last Data Received Date.'
																		);
																		return Promise.reject({});
																	}
																	var payload = {};
																	if (data.runDate) {
																		payload.runDate = data.runDate;
																	}
																	if (data.lastDataReceivedDate) {
																		payload.lastDataReceivedDate = data.lastDataReceivedDate;
																	}
																	return DataManagementService.getIntegrationService().updatePullDates(
																		record.configId,
																		data.configFileId,
																		payload
																	);
																},
																success: function() {
																	window.DL.MessageUtil.showToast('Success', 'Updated Pull Dates', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	updateWin.close();
																}
															});
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															updateWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});
						updateWin.addToContentElement(formPanel);
					}
				}
			});
		};

		var connectivityCheckStorageKey = function(configId) {
			return DataManagementService.getIntegrationService().getConnectivityCheckStorageKey(configId);
		};

		var clearConnectivityCheckStorage = function(configId) {
			SessionStorageUtil.removeItem(connectivityCheckStorageKey(configId));
		};

		var formatConnectivityElapsed = function(elapsedMs) {
			if (elapsedMs === null || elapsedMs < 0) {
				return '';
			}
			var totalSeconds = Math.floor(elapsedMs / 1000);
			var minutes = Math.floor(totalSeconds / 60);
			var seconds = totalSeconds % 60;
			if (minutes > 0) {
				return minutes + 'm ' + seconds + 's';
			}
			return seconds + 's';
		};

		var renderConnectivityCheckRows = function(contentWrap, checks, stepElapsedOverrides, stepOpenState) {
			stepOpenState = stepOpenState || {};

			contentWrap.querySelectorAll('vaadin-details[data-check-order]').forEach(function(el) {
				stepOpenState[el.getAttribute('data-check-order')] = el.opened;
			});

			while (contentWrap.firstChild) {
				contentWrap.removeChild(contentWrap.firstChild);
			}
			if (!checks || checks.length === 0) {
				var emptyMsg = document.createElement('div');
				emptyMsg.style.padding = '16px';
				emptyMsg.textContent = 'No check results yet.';
				contentWrap.appendChild(emptyMsg);
				return;
			}
			checks.forEach(function(row) {
				var success = row.success;
				var stepStatus = row.stepStatus;
				var headerBg = '#e8f5e9';
				var iconName = 'vaadin:check-circle';
				var iconColor = '#2e7d32';
				if (stepStatus === 'RUNNING') {
					headerBg = '#e3f2fd';
					iconName = 'vaadin:refresh';
					iconColor = '#1565c0';
				} else if (stepStatus === 'PENDING') {
					headerBg = '#f5f5f5';
					iconName = 'vaadin:hourglass';
					iconColor = '#616161';
				} else if (stepStatus === 'CANCELLED') {
					headerBg = '#f5f5f5';
					iconName = 'vaadin:minus-circle-o';
					iconColor = '#616161';
				} else if (success === false) {
					headerBg = '#ffebee';
					iconName = 'vaadin:close-circle';
					iconColor = '#c62828';
				} else if (success === null) {
					headerBg = '#f5f5f5';
					iconName = 'vaadin:minus-circle-o';
					iconColor = '#616161';
				}

				var titleText = row.checkName || 'Check';
				var elapsedMs = row.elapsedMs;
				if (stepElapsedOverrides && stepElapsedOverrides[row.order] !== null) {
					elapsedMs = stepElapsedOverrides[row.order];
				}
				if (stepStatus === 'RUNNING' && elapsedMs !== null) {
					titleText += ' — ' + formatConnectivityElapsed(elapsedMs);
				}

				var summaryRow = ElementUtil.create({
					tag: 'div',
					slot: 'summary',
					style: 'display: flex; align-items: center; gap: 10px; padding: 10px 12px; color: #000000; background-color: ' + headerBg + '; border-radius: 4px; font-weight: 600;',
					children: [
						{
							tag: 'vaadin-icon',
							icon: iconName,
							style: 'color: ' + iconColor + '; width: 1.25em; height: 1.25em; flex-shrink: 0;'
						},
						{
							tag: 'span',
							innerHTML: titleText
						}
					]
				});

				var bodyDiv = ElementUtil.create({
					tag: 'div',
					style: 'padding: 12px 16px; line-height: 1.5;'
				});
				if (stepStatus === 'RUNNING') {
					var progressLine = document.createElement('div');
					progressLine.textContent = 'In progress…';
					bodyDiv.appendChild(progressLine);
				}
				if (row.checkMessage) {
					var msgLine = document.createElement('div');
					msgLine.textContent = row.checkMessage;
					if (bodyDiv.childNodes.length > 0) {
						msgLine.style.marginTop = '8px';
					}
					bodyDiv.appendChild(msgLine);
				}
				if (row.failMessage) {
					var failLine = document.createElement('div');
					failLine.style.marginTop = '8px';
					failLine.style.whiteSpace = 'pre-wrap';
					failLine.style.wordBreak = 'break-word';
					failLine.textContent = row.failMessage;
					bodyDiv.appendChild(failLine);
				}
				if (row.rawFailMessage) {
					var rawDiv = document.createElement('div');
					rawDiv.style.marginTop = '10px';
					rawDiv.style.fontSize = '12px';
					rawDiv.style.overflow = 'auto';
					rawDiv.style.maxHeight = '200px';
					rawDiv.innerHTML = row.rawFailMessage;
					bodyDiv.appendChild(rawDiv);
				}

				var orderKey = String(row.order);
				var opened = Object.prototype.hasOwnProperty.call(stepOpenState, orderKey)
					? stepOpenState[orderKey]
					: stepStatus === 'RUNNING';

				var detailsEl = ElementUtil.create({
					tag: 'vaadin-details',
					'data-check-order': orderKey,
					style: 'margin-bottom: 10px;',
					properties: {
						opened: opened
					},
					listeners: {
						'opened-changed': function(event) {
							stepOpenState[orderKey] = event.detail.value;
						}
					},
					children: [summaryRow, bodyDiv]
				});

				contentWrap.appendChild(detailsEl);
			});
		};

		var updateRunningStepElapsedLabels = function(contentWrap, checks, stepElapsedOverrides) {
			if (!checks || !contentWrap) {
				return;
			}
			contentWrap.querySelectorAll('vaadin-details[data-check-order]').forEach(function(el) {
				var orderKey = el.getAttribute('data-check-order');
				var row = checks.find(function(check) {
					return String(check.order) === orderKey;
				});
				if (!row || row.stepStatus !== 'RUNNING') {
					return;
				}
				var titleSpan = el.querySelector('[slot="summary"] span');
				if (!titleSpan) {
					return;
				}
				var elapsedMs = row.elapsedMs;
				if (stepElapsedOverrides && stepElapsedOverrides[row.order] !== null) {
					elapsedMs = stepElapsedOverrides[row.order];
				}
				var titleText = row.checkName || 'Check';
				if (elapsedMs !== null) {
					titleText += ' — ' + formatConnectivityElapsed(elapsedMs);
				}
				titleSpan.textContent = titleText;
			});
		};

		var openConnectivityResultsDialog = function(record, sessionId, resume) {
			var integrationService = DataManagementService.getIntegrationService();
			var configId = record.configId;
			var pollIntervalId = null;
			var elapsedIntervalId = null;
			var latestView = null;
			var stepOpenState = {};

			var stopTimers = function() {
				if (pollIntervalId) {
					clearInterval(pollIntervalId);
					pollIntervalId = null;
				}
				if (elapsedIntervalId) {
					clearInterval(elapsedIntervalId);
					elapsedIntervalId = null;
				}
			};

			var updateHeaderElapsed = function(headerEl) {
				if (!headerEl || !latestView) {
					return;
				}
				if (latestView.complete) {
					headerEl.textContent = 'Completed in ' + formatConnectivityElapsed(latestView.elapsedMs);
					return;
				}
				var elapsedMs = latestView.elapsedMs;
				if (latestView.createdDts) {
					elapsedMs = Date.now() - new Date(latestView.createdDts).getTime();
				}
				headerEl.textContent = 'Running… ' + formatConnectivityElapsed(elapsedMs);
			};

			var updateStepElapsedOverrides = function() {
				var overrides = {};
				if (!latestView || !latestView.checks) {
					return overrides;
				}
				var now = Date.now();
				latestView.checks.forEach(function(check) {
					if (check.stepStatus === 'RUNNING' && check.startedDts) {
						overrides[check.order] = now - new Date(check.startedDts).getTime();
					}
				});
				return overrides;
			};

			var refreshUi = function(contentWrap, headerEl, cancelBtn) {
				if (!latestView) {
					return;
				}
				updateHeaderElapsed(headerEl);
				renderConnectivityCheckRows(contentWrap, latestView.checks, updateStepElapsedOverrides(), stepOpenState);
				if (cancelBtn) {
					cancelBtn.disabled = !latestView.cancellable;
				}
				if (latestView.complete) {
					stopTimers();
					clearConnectivityCheckStorage(configId);
				}
			};

			var pollStatus = function(contentWrap, headerEl, cancelBtn) {
				integrationService.getConnectivityCheckStatus(configId, sessionId).then(function(view) {
					latestView = view;
					SessionStorageUtil.setItem(connectivityCheckStorageKey(configId), sessionId);
					refreshUi(contentWrap, headerEl, cancelBtn);
				}).catch(function() {
					stopTimers();
				});
			};

			var connectivityWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Connectivity Check',
				icon: 'vaadin:check-circle',
				width: 0.55,
				height: 0.65,
				listeners: {
					ready: function() {
						connectivityWin.show();

						var headerEl = ElementUtil.create({
							tag: 'div',
							style: 'padding: 0 4px 12px 4px; font-size: 14px; color: #e7e7e7;',
							itemid: 'connectivity-header-status'
						});
						if (resume) {
							headerEl.textContent = 'Resuming connectivity check…';
						}

						var contentWrap = ElementUtil.create({
							tag: 'div',
							style: 'box-sizing: border-box; min-height: 120px;',
							itemid: 'connectivity-results-root'
						});

						var cancelBtn = ElementUtil.create({
							tag: 'vaadin-button',
							innerHTML: 'Cancel',
							listeners: {
								click: function() {
									cancelBtn.disabled = true;
									cancelBtn.innerHTML = 'Cancelling…';
									integrationService.cancelConnectivityCheck(configId, sessionId).then(function(view) {
										latestView = view;
										refreshUi(contentWrap, headerEl, cancelBtn);
									});
								}
							}
						});

						var closeBtn = ElementUtil.create({
							tag: 'vaadin-button',
							theme: 'primary',
							innerHTML: 'Close',
							listeners: {
								click: function() {
									if (latestView && latestView.cancellable) {
										window.DL.MessageUtil.showConfirm({
											title: 'Cancel connectivity check?',
											message: 'Do you want to cancel the current connectivity check session?',
											buttons: [
												{
													text: 'Yes, cancel',
													theme: 'primary',
													handler: function() {
														integrationService.cancelConnectivityCheck(configId, sessionId).then(function() {
															stopTimers();
															clearConnectivityCheckStorage(configId);
															connectivityWin.close();
														});
													}
												},
												{
													text: 'No',
													handler: function() {
													}
												}
											]
										});
									} else {
										stopTimers();
										clearConnectivityCheckStorage(configId);
										connectivityWin.close();
									}
								}
							}
						});

						var footerBar = ElementUtil.create({
							tag: 'div',
							style: 'padding-top: 16px; margin-top: 12px; text-align: center; border-top: 1px solid var(--lumo-contrast-10pct, #ddd); display: flex; gap: 12px; justify-content: center;',
							children: [cancelBtn, closeBtn]
						});

						var outerLayout = ElementUtil.create({
							tag: 'div',
							children: [headerEl, contentWrap, footerBar]
						});

						connectivityWin.addToContentElement(outerLayout);
						SessionStorageUtil.setItem(connectivityCheckStorageKey(configId), sessionId);

						var loadMask = outerLayout.showLoading(resume ? 'Loading session…' : 'Starting checks…');
						pollStatus(contentWrap, headerEl, cancelBtn);
						loadMask.remove();

						pollIntervalId = setInterval(function() {
							pollStatus(contentWrap, headerEl, cancelBtn);
						}, 5000);

						elapsedIntervalId = setInterval(function() {
							if (latestView) {
								updateHeaderElapsed(headerEl);
								updateRunningStepElapsedLabels(contentWrap, latestView.checks, updateStepElapsedOverrides());
							}
						}, 1000);
					}
				}
			});
		};

		var promptAndStartConnectivityCheck = function(record) {
			var integrationService = DataManagementService.getIntegrationService();
			integrationService.getConnectivityCheckOptions(record.configId).then(function(options) {
				var policy = options.policy;
				var policyMessage = options.policyMessage || '';
				var startSession = function(executionMode) {
					integrationService.startConnectivityCheck(record.configId, executionMode).then(function(view) {
						if (view && view.sessionId) {
							var resumeExisting = view.cancellable === true && view.checks && view.checks.length > 0;
							openConnectivityResultsDialog(record, view.sessionId, resumeExisting);
						}
					}).catch(function() {
						window.DL.MessageUtil.showToastError('Unable to start connectivity check.');
					});
				};

				if (policy === 'SEQUENTIAL_OR_PARALLEL') {
					var parallelHint = 'Parallel runs checks at the same time (faster). Sequential is recommended for OAuth and rate-limited providers.';
					window.DL.MessageUtil.showConfirm({
						title: 'Connectivity Check',
						message: (policyMessage ? policyMessage + '<br/><br/>' : '') + parallelHint,
						buttons: [
							{
								text: 'Run Sequential',
								theme: 'primary',
								handler: function() {
									startSession('SEQUENTIAL');
								}
							},
							{
								text: 'Run Parallel',
								handler: function() {
									startSession('PARALLEL');
								}
							},
							{
								text: 'Cancel'
							}
						]
					});
				} else {
					window.DL.MessageUtil.showConfirm({
						title: 'Connectivity Check',
						message: policyMessage || 'Run connectivity checks sequentially (login, vehicles, GPS, and custom).',
						buttons: [
							{
								text: 'Run',
								theme: 'primary',
								handler: function() {
									startSession('SEQUENTIAL');
								}
							},
							{
								text: 'Cancel'
							}
						]
					});
				}
			}).catch(function() {
				window.DL.MessageUtil.showToastError('Unable to load connectivity check options.');
			});
		};

		var actionCheckConnectivity = function(record) {
			var integrationService = DataManagementService.getIntegrationService();
			var configId = record.configId;

			integrationService.getActiveConnectivityCheck(configId).then(function(activeView) {
				if (activeView && activeView.sessionId) {
					openConnectivityResultsDialog(record, activeView.sessionId, true);
					return;
				}
				var storedSessionId = SessionStorageUtil.getItem(connectivityCheckStorageKey(configId));
				if (storedSessionId) {
					integrationService.getConnectivityCheckStatus(configId, storedSessionId).then(function(view) {
						if (view && !view.complete && view.cancellable) {
							openConnectivityResultsDialog(record, storedSessionId, true);
						} else {
							clearConnectivityCheckStorage(configId);
							promptAndStartConnectivityCheck(record);
						}
					}).catch(function() {
						clearConnectivityCheckStorage(configId);
						promptAndStartConnectivityCheck(record);
					});
				} else {
					promptAndStartConnectivityCheck(record);
				}
			}).catch(function() {
				promptAndStartConnectivityCheck(record);
			});
		};
		
		var actionResetRunStatus = function(records) {			
			var multiIds = {
				ids: []
			};																	
			records.forEach(function(item){
				multiIds.ids.push(
					 item.configId
				);
			});
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Reset',
				message: '<b>Are you sure you want to reset the selected integrations?</b><br>This will only cancel non-active configurations.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Resetting Integration(s)...');

							DataManagementService.getIntegrationService().resetRunStatus(multiIds)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Reset Integration(s)', {									
									theme: 'success'
								});
								actionRefresh();
							}, function(){
							    loadMask.remove();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
		};
		
		var actionUpdateStatus = function(records) {
			var updateWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Update Status',
				icon: 'vaadin:arrow-circle-up',				
				width: 400,
				height: 200,
				listeners: {
					ready: function() {						
						updateWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [														
										{
											tag: 'vaadin-combo-box',											
											label: 'New Status', 
											name: 'status',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function(combo) {
												DataManagementService.getIntegrationService().getAvailableStatus().then(function(data){
													// Pending is create-default only; change-status supports A/I/S.
													combo.items = data.filter(function(status) {
														return !status.systemSet && status.code !== 'P';
													});
												});
											}	
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															

															formPanel.submitForm({
																preSubmit: function(data) {
																	return data;
																},
																actualCall: function(data) {	
																	var multiIds = {
																		ids: []
																	};																	
																	records.forEach(function(item){
																		multiIds.ids.push(
																			item.configId
																		);
																	});
																	
																	return DataManagementService.getIntegrationService().changeStatus(multiIds, data.status);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Updated Status', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	if (formPanel.successCallback) {
																		formPanel.successCallback();
																	}
																	actionRefresh();
																	updateWin.close();
																}
															});

														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															updateWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						updateWin.addToContentElement(formPanel);	
						
					}
				}
			});			
		};
		
		var actionRequestTrouble = function(record) {
			//prompt for description of issue
			var updateWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Request Support',
				icon: 'vaadin:arrow-circle-up',				
				width: 600,
				height: 400,
				listeners: {
					ready: function() {						
						updateWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [														
										{
											tag: 'vaadin-text-area',											
											label: 'Description of Issue', 
											name: 'comment',											
											required: true,
											postinit: function(combo) {											
											}	
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Submit')
													],
													listeners: {
														click: function() {															

															formPanel.submitForm({
																preSubmit: function(data) {
																	return data;
																},
																actualCall: function(data) {																																			
																	return DataManagementService.getIntegrationService().submitFeedback(record.configId, data);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Submited Support Ticket', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	if (formPanel.successCallback) {
																		formPanel.successCallback();
																	}
																	actionRefresh();
																	updateWin.close();
																}
															});

														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															updateWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						updateWin.addToContentElement(formPanel);	
						
					}
				}
			});	
			
		};
		
		var actionTransmissionProperties = function() {
			IntegrationProperties.transmissionProperties();
		};
	
		var actionTemplates = function() {
			IntegrationProperties.manageTemplates(transmissionTypes);
		};
		
		var actionLocks = function() {
			IntegrationLocks.manageLocks();		
		};
	
		var actionShowDetails = function(record) {
			IntegrationDetails.showDetails(record);
		};
	
		var actionDelete = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected integration?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing Integration...');

							DataManagementService.getIntegrationService().deleteIntegration(record.configId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed Integration', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};
	
	}
	
}
customElements.define('dl-integration-grid', IntegrationGrid);



